import { ActionFunction } from 'react-router-dom'

import Collection from '@models/Collection'
import ApiRoutes from '@utils/api-routes'
import http from '@utils/http'

const updateCollectionAction: ActionFunction = async ({ request }) => {
  const formData = await request.formData()
  formData.delete('showSearch')
  return http.action.post<UpdateCollectionResponse>(ApiRoutes.collections.updatePath(), formData)
}

export default updateCollectionAction

export type UpdateCollectionResponse = {
  collection: Collection
}
